import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

export interface CategoryDimensionOptionRow {
	CategoryDimensionOption_ID: number;
	CategoryDimensionOption_UID: string;
	CategoryDimension_fk: number;
	IsTextbox: number | null;
	Sequence: number;
	CreatedBy: string;
	CreatedDate: string;
	UpdatedBy: string | null;
	UpdatedDate: string | null;
	IsDeleted: number;
	IsDefault: number;
	Locale: string;
	LocalizedValue: string;
}

type GetCategoryDimensionOptionsParams = {
	portalId: number;
	categoryDimensionUid: string | null;
	enabled?: boolean;
};

const fetchCategoryDimensionOptions = async (
	portalId: number,
	categoryDimensionUid: string,
): Promise<CategoryDimensionOptionRow[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getCategoryDimensionOptions",
		bind: {
			portalId,
			categoryDimension: categoryDimensionUid,
		},
	});

	return response.data.result;
};

export const useGetCategoryDimensionOptions = ({ portalId, categoryDimensionUid, enabled = true }: GetCategoryDimensionOptionsParams) => {
	return useQuery<CategoryDimensionOptionRow[]>({
		queryKey: ["getCategoryDimensionOptions", portalId, categoryDimensionUid],
		queryFn: () => fetchCategoryDimensionOptions(portalId, categoryDimensionUid!),
		enabled: !!categoryDimensionUid && !!portalId && enabled,
	});
};
